import { useCallback, useMemo } from 'react';
import { useSmartNavigate } from 'hooks/useSmartNavigate';
import { useLocation } from '@reach/router';

const TRAILING_SLASH = /\/$/;

export function useCloseNavigate(path?: string) {
  const location = useLocation();
  const navigate = useSmartNavigate();

  const target = useMemo(() => {
    const { pathname } = location;
    const pathnameParts = pathname.replace(TRAILING_SLASH, '').split('/');
    const pathParts = path?.replace(TRAILING_SLASH, '').split('/') || '';

    if (path?.includes('../') || path?.includes('./')) return path;
    if (pathnameParts.length < pathParts.length) return pathnameParts.join('/');

    return pathnameParts.slice(0, pathnameParts.length - pathParts.length).join('/');
  }, [location, path]);

  return useCallback(() => navigate(target), [navigate, target]);
}
